export { WithImagesAndDescriptionsVariation as default } from './WithImagesAndDescriptionsVariation';
